import {
    getMarkerTypeConfig,
    hasMarkerAvatarData,
    normalizeMarkerType,
} from './markerTypeConfig';

const HEX_COLOR_PATTERN = /^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;
const DEFAULT_MARKER_COLOR = '#5f8cff';

export function sanitizeMarkerColor(value, fallback = DEFAULT_MARKER_COLOR) {
    if (typeof value !== 'string') {
        return fallback;
    }
    const trimmed = value.trim();
    const match = HEX_COLOR_PATTERN.exec(trimmed);
    if (!match) {
        return fallback;
    }
    const hex = match[1];
    if (hex.length === 3) {
        const expanded = hex.split('').map((char) => `${char}${char}`).join('');
        return `#${expanded.toLowerCase()}`;
    }
    return `#${hex.toLowerCase()}`;
}

function safeText(value) {
    if (typeof value !== 'string') {
        return '';
    }
    return value.replace(/[\r\n\t]/g, ' ').trim();
}

export function buildMarkerListItemModel(marker, { markerColors, t, formatDateTime } = {}) {
    const normalizedType = normalizeMarkerType(marker.type);
    const config = getMarkerTypeConfig(normalizedType);
    const typeLabel = config.label;
    const title = marker.name || typeLabel;
    const color = sanitizeMarkerColor(markerColors?.[normalizedType]);
    const author = safeText(marker.authorName);
    const authorUsername = safeText(
        marker.metadata?.username
        || marker.metadata?.displayName
        || marker.metadata?.authorName
        || marker.authorName,
    );
    const avatar = config.extractAvatar(marker, marker.metadata || {}, author, authorUsername);
    const hasAvatar = hasMarkerAvatarData(avatar);

    return {
        id: marker.id,
        title,
        typeLabel,
        markerColor: color,
        iconMode: config.iconMode,
        avatar,
        hasAvatar,
        marker,
    };
}
